import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import ElevateYourRentalExperience from "./sections/ElevateYourRentalExperience";
import TheParadisePalmsExperience from "./sections/TheParadisePalmsExperience";
import TheVisualStory from "./sections/TheVisualStory";
import OurExpertise from "./sections/OurExpertise";
import TransparentStayPricing from "./sections/TransparentStayPricing";
import WhatOurClientsSee from "./sections/WhatOurClientsSee";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <ElevateYourRentalExperience />
      <TheParadisePalmsExperience />
      <TheVisualStory />
      <OurExpertise />
      <TransparentStayPricing />
      <WhatOurClientsSee />
      <Footer />
    </div>;
}